import React, { useContext, useState } from 'react'
import { Sidebar } from './sidebar'
import { Checkbox } from 'antd'
import { useCustomFetch } from '../../hooks/useCustomFetch'
import toast from 'react-hot-toast'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import evermuseLogo from '@/assets/evermuse-logo-21h.svg'

export function CreateWorkspace() {
  const { user, setUser } = useContext(AuthContext)
  const [searchParams] = useSearchParams()
  const [workspaceName, setWorkspaceName] = useState('')
  const [allowMailExtension, setAllowMailExtension] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const customFetch = useCustomFetch()

  if (!user || !user.email) return

  const split = user.email.split('@')
  if (split.length < 2) throw new Error('Error with user extension')
  const mailExtension = split[1]
  const showMailExtension =
    mailExtension !== 'gmail.com' &&
    mailExtension !== 'googlemail.com' &&
    mailExtension !== 'outlook.com' &&
    mailExtension !== 'hotmail.com' &&
    !mailExtension.endsWith('.onmicrosoft.com')

  async function createWorkspace() {
    try {
      if (!workspaceName) return toast.error('Please enter a workspace name')
      setIsLoading(true)
      const response = await customFetch('/createWorkspace', 'POST', {
        name: workspaceName,
        mailExtension: showMailExtension && allowMailExtension ? mailExtension : undefined,
      })
      if (response.error) throw new Error(response.error)
      if (!Object.keys(response.newWorkspace).length) throw new Error('Error getting new workspace')
      setUser((prevUser) => ({
        ...prevUser,
        workspaces: { ...prevUser.workspaces, ...response.newWorkspace },
        active_workspace: Object.keys(response.newWorkspace)[0],
      }))
      toast.success('Workspace created!')
      setIsLoading(false)
      const planId = searchParams.get('plan_id')
      if (planId) navigate(`/dashboard/home-new?plan_id=${planId}`)
      else navigate('/dashboard/home-new')
    } catch (error) {
      console.error('Error creating workspace', error)
      toast.error('Error creating workspace')
      setIsLoading(false)
    }
  }

  return (
    <div className="h-full flex">
      <div className="w-3/5">
        <div className="my-24 mx-36">
          <div className="mb-20">
            <img src={evermuseLogo} alt="Evermuse" width="170" height="21" />
          </div>

          <p className="text-3xl font-bold font-['DM_Sans'] text-zinc">Create a Workspace</p>
          <p className="text-l font-medium font-['DM_Sans'] text-zinc my-2">
            A workspace is a space for your organization to <br /> collaborate on user research projects.
          </p>
          <div className="mt-[40px] flex items-center">
            <p className="text-[#40424A] text-xs font-extrabold font-['Manrope'] uppercase leading-[13.20px] tracking-wide">
              Workspace name
            </p>
            <p className="ml-[5px] mt-[5px] text-[#FF4A8E] text-[24px] font-medium font-['DM_Sans']">*</p>
          </div>
          <input
            className="w-[601px] px-5 py-2.5 bg-grey-100 rounded shadow-inner border border-grey-200 placeholder-grey-400"
            placeholder="Enter Workspace Name"
            value={workspaceName}
            onChange={(e) => setWorkspaceName(e.target.value)}
          />
          {showMailExtension && (
            <div className="mt-4 flex items-center">
              <Checkbox checked={allowMailExtension} onChange={(e) => setAllowMailExtension(e.target.checked)} />
              {/* <Checkbox checked={allowMailExtension} onClick={() => setAllowMailExtension(!allowMailExtension)} /> */}
              <div className="ml-2">
                <span className="text-black text-lg font-normal font-['DM_Sans'] leading-[23px]">
                  Accept anyone with an{' '}
                </span>
                <span className="text-black text-lg font-bold font-['DM_Sans'] leading-[23px]">@{mailExtension} </span>
                <span className="text-black text-lg font-normal font-['DM_Sans'] leading-[23px]">address</span>
              </div>
            </div>
          )}
          <button
            className="ml-[382px] mt-[71px] w-[219px] h-12 px-[30px] py-3.5 bg-[#FF4A8E] rounded justify-center items-center gap-2.5 inline-flex disabled:opacity-60 disabled:cursor-not-allowed"
            onClick={createWorkspace}
            disabled={isLoading}
          >
            <p className="text-center text-white text-lg font-medium font-['DM_Sans'] leading-tight">
              {isLoading ? 'Creating...' : 'Create & Continue'}
            </p>
          </button>
        </div>
      </div>
      <div className="w-2/5 bg-grey-100">
        <Sidebar />
      </div>
    </div>
  )
}
